import { Controller } from '@hotwired/stimulus';

export default class ScaConsentCallbackController extends Controller {
  static targets = ['pending', 'success', 'error']
  static values = {
    profileId: String
  }

  connect() {
    this.subscribeToChannel()
    this.startTimeout()
  }

  disconnect() {
    if (this.subscription) {
      this.subscription.unsubscribe()
    }
    if (this.timeoutId) {
      clearTimeout(this.timeoutId)
    }
  }

  subscribeToChannel() {
    this.subscription = App.cable.subscriptions.create(
      {
        channel: 'ScaConsentChannel',
        profile_id: this.profileIdValue
      },
      {
        received: (data) => {
          if (data.status === 'success') {
            this.showSuccess()
          } else if (data.status === 'failed') {
            this.showError()
          }
        }
      }
    )
  }

  startTimeout() {
    this.timeoutId = setTimeout(() => {
      this.showError()
    }, 45000) // 45 secondes
  }

  showSuccess() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId)
    }
    this.pendingTarget.classList.add('d-none')
    this.successTarget.classList.remove('d-none')
  }

  showError() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId)
    }
    this.pendingTarget.classList.add('d-none')
    this.errorTarget.classList.remove('d-none')
  }
}
